// extracted by mini-css-extract-plugin
export default {"container":"Plans_container__xewTb","heading":"Plans_heading__J+DlO","plans":"Plans_plans__7mqfb"};